import { BestOfRingVideo } from '@amzn/ring-neighbors-contentful-gql-schema';

export function getReturnType<R>(_f: (...args: any[]) => R): { returnType: R } {
  return null!;
}

export const buildPageTitle = (
  videoIndex: number,
  videoList?: BestOfRingVideo[],
) => {
  const pageTitle = 'Best of Ring';
  if (videoIndex >= 0 && videoList && videoList.length >= 1) {
    return `${pageTitle} - ${videoList[videoIndex].title}`;
  }
  return pageTitle;
};
